// This file is auto-generated

import deCH from './ackermannch/de-CH.json';
import frCH from './ackermannch/fr-CH.json';

const messages = { 'de-CH': deCH, 'fr-CH': frCH };

export default messages;
